
import PathSquare from "../../../assets/duotone/PathSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PathSquareIcon({ className, dataTestid = "PathSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <PathSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
